//import {Link, BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import React, { useEffect, useRef, useState } from 'react';
import apis from '../../api';
import { Div, Form, FormGroup, Forms, Label } from './CreatePerson.styles';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import uploadFileS3 from '../../services/uploadFileS3';
import useWindowDimensions from '../hooks/useDimensions';
import { Link, useHistory } from "react-router-dom";
import './CreatePerson.css'

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CreatePerson
Description : Creación de un empleado y su información personal.
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa el forumlario desde cero.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo los cambios realizados con PrimeReact
================================================================================ */

export default function CreatePerson(props) {

    var _ = require('lodash'); //Para comparar objetos json

    /*Propiedades del componente*/
    const [id, setId] = useState("");
    const [tipoDocumento, setTipoDocumento] = useState("");
    const [documento, setDocumento] = useState("");
    const [nombre, setNombre] = useState("");
    const [otroNombre, setOtroNombre] = useState("");
    const [apellido1, setApellido1] = useState("");
    const [apellido2, setApellido2] = useState("");
    const [direccion, setDireccion] = useState("");
    const [pais, setPais] = useState("");
    const [departamento, setDepartamento] = useState("");
    const [ciudad, setCiudad] = useState("");
    const [email, setEmail] = useState("");
    const [existe, setExiste] = useState(false);
    const [persona, setPersona] = useState("")
    const [pin, setPin] = useState("");
    const [fotoEmpleado, setFotoEmpleado] = useState(localStorage.getItem('image') ? localStorage.getItem('image') : "");
    const [otherData, setOtherData] = useState({
        "CORPORATE_MAIL": "",
        "BIRTH_DATE": "",
        "LOV_CITY_BIRTH": "",
        "LOV_DEPARTMENT_BIRTH": "",
        "LOV_COUNTRY_BIRTH": "",
        "EXPEDITION_DATE": "",
        "LOV_EXPEDITION_COUNTRY": "",
        "LOV_EXPEDITION_CITY": "",
        "NEIGHBORHOOD": "",
        "PHONE_HOME": "",
        "CELL_PHONE1": "",
        "CELL_PHONE2": "",
        "LOV_BLOOD_TYPE": "",
        "LOV_MARITAL_STATUS": "",
        "LOV_GENDER": "",
    })

    /*Listas de valores del componente*/
    const [listaTipoDocumento, setListaTipoDocumento] = useState([{ "value": "", "label": "" }]);
    const [listaPais, setListaPais] = useState([{ "value": "", "label": "" }]);
    const [listaDepartamento, setListaDepartamento] = useState([]);
    const [listaCiudad, setListaCiudad] = useState([]);
    const [optionsListaTipoDocumento, setOptionsListaTipoDocumento] = useState([]);
    const [optionsListaPais, setOptionsListaPais] = useState([]);
    const [optionsListaDepartamento, setOptionsListaDepartamento] = useState([]);
    const [optionsListaCiudad, setOptionsListaCiudad] = useState([]);
    const [listasValores, setListasValores] = useState({});
    const [didMount, setDidMount] = useState(false);

    const [loading1, setLoading1] = useState(false);
    const [loadPage, setLoadPage] = useState(false);

    const { width } = useWindowDimensions()

    /*Constantes globales para el componente*/
    const headers = {
        authorization: localStorage.getItem('token')
    }
    const elementWidth = { width: width > 873 ? "20rem" : '100%' }
    const cardStyle = {
        width: width < 960 ? "100%" : "60vw",
        // display: 'flex',
        marginBottom: "1rem",
        justifyContent: "center",
        alignItems: 'center',
        boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.06), 0px 7px 9px rgba(0, 0, 0, 0.12), 0px 20px 25px -8px rgba(0, 0, 0, 0.18)'
    }
    const toast = useRef(null);
    const fileUploadRef = useRef(null);

    useEffect(() => {
        /*Se cargan los datos de las listas de valores del componente*/
        const template = async () => {
            try {
                await apis.getValueListIdentity(headers).then(res => {
                    let data = res.data
                    let tipoDoc = data["TIPO DE IDENTIDAD"];
                    let paises = data["PAISES"]
                    let contenidoTipoDoc = [];
                    tipoDoc.forEach(element =>
                        contenidoTipoDoc.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    setOptionsListaTipoDocumento(tipoDoc);
                    setOptionsListaPais(paises);
                    setListasValores(data);
                    setListaTipoDocumento(contenidoTipoDoc);

                }
                )
            } catch (err) {
                console.log(err.response)
            }
        }
        template()
    }, [])

    useEffect(() => {
        /*Se carga la infromaión de la persona, en caso de que exista*/
        setId("")
        loadPersonInformation()
    }, [documento])

    useEffect(() => {
        /*Se cargan los datos de las listas de valores de pais, departamento y ciudad del componente*/
        setPaises()
    }, [pais, departamento, optionsListaPais])

    async function setPaises() {
        /*Función encargada de cargar los datos de las listas de valores de país, departamento y ciudad del componente*/
        let contenidoPaises = []
        let contenidoDepartamentos = []
        let contenidoCiudades = []
        optionsListaPais.forEach(element => {
            let deps = []
            if (element.DEPARTAMENTO) {
                let dep = element.DEPARTAMENTO
                dep.forEach(d => {
                    let cities = []
                    if (d.CIUDADES) {
                        let city = d.CIUDADES
                        city.forEach(c =>
                            cities.push({ "code": '' + c.detail_id + '', "cname": '' + c.description + '' })
                        )
                    }
                    deps.push({ "code": '' + d.detail_id + '', "name": '' + d.description + '', "cities": cities })
                })
            }
            contenidoPaises.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '', "states": deps })
        })
        setListaPais(contenidoPaises);
        try {
            let _pais = contenidoPaises.filter((p) => p.value === pais.value)
            if (_pais[0].states.length !== 0) {
                contenidoDepartamentos = _pais[0].states
            }
            if (contenidoDepartamentos.length !== 0) {
                let _departamento = contenidoDepartamentos.filter((d) => d.code === departamento.value)
                if (_departamento !== undefined && _departamento.length !== 0) {
                    if (_departamento[0].cities.length > 0) {
                        contenidoCiudades = _departamento[0].cities
                    }
                }
            }
            setListaDepartamento(contenidoDepartamentos);
            setListaCiudad(contenidoCiudades);
        } catch (err) {
            console.log("Wait")
        }
    }

    async function cleanPerson() {
        /*Función que reinicia los valores de las propiedades del componente*/
        setNombre("");
        setOtroNombre("");
        setApellido1("");
        setApellido2("");
        setDireccion("");
        setPais("");
        setDepartamento("");
        setCiudad("");
        setEmail("");
    }

    function validateForm() {
        /*Función que valida los valores de los campos de entrada del componente*/
        return tipoDocumento != "" && documento != "" && nombre != "" &&
            apellido1 != "" && direccion != "" && pais != "" && email != "";
    }

    function handleSubmit(event) {
        event.preventDefault();
    }

    async function loadPersonInformation() {
        /*Función que carga la información de la persona, si esta existe*/
        let doc = ""
        let entity = localStorage.getItem('entity')
        let client = localStorage.getItem('client')
        let token = localStorage.getItem('token')
        if (localStorage.getItem("number_id")) {
            doc = localStorage.getItem("number_id")
        }
        else {
            doc = documento
        }

        try {
            await apis.getIdentity(entity, client, doc, token, headers).then(res => {
                if (res.data["PERSON"] != []) {
                    let defaultData = res.data["PERSON"][0]
                    let foto = defaultData["IMAGES"] ? defaultData["IMAGES"] : process.env.REACT_APP_PROFILE_PIC
                    let defaultDocType = defaultData["DOCUMENT_TYPE"].split("|")
                    let defaultNumberId = defaultData["NUMBER_ID"]
                    let defaultLastName = defaultData["LASTNAME"]
                    let defaultOtherLastName = defaultData["OTHER_LASTNAME"]
                    let defaultName = defaultData["NAME"]
                    let defaultOtherName = defaultData["OTHER_NAME"]
                    let defaultAddress = defaultData["ADDRESS"]
                    let defaultCountry = defaultData["COUNTRY"].split("|")
                    let defaultDepartment = defaultData["DEPARTMENT"].split("|")
                    let defaultCity = defaultData["CITY"].split("|")
                    let defaultEmail = defaultData["EMAIL"]
                    let defaultPin = defaultData["PIN"]
                    const defaultOtherData = {
                        "CORPORATE_MAIL": defaultData["CORPORATE_MAIL"],
                        "BIRTH_DATE": defaultData["BIRTH_DATE"],
                        "LOV_CITY_BIRTH": defaultData["LOV_CITY_BIRTH"].split("|")[0],
                        "LOV_DEPARTMENT_BIRTH": defaultData["LOV_DEPARTMENT_BIRTH"].split("|")[0],
                        "LOV_COUNTRY_BIRTH": defaultData["LOV_COUNTRY_BIRTH"].split("|")[0],
                        "EXPEDITION_DATE": defaultData["EXPEDITION_DATE"].split("|")[0],
                        "LOV_EXPEDITION_COUNTRY": defaultData["LOV_EXPEDITION_COUNTRY"].split("|")[0],
                        "LOV_EXPEDITION_CITY": defaultData["LOV_EXPEDITION_CITY"].split("|")[0],
                        "NEIGHBORHOOD": defaultData["NEIGHBORHOOD"],
                        "PHONE_HOME": defaultData["PHONE_HOME"],
                        "CELL_PHONE1": defaultData["CELL_PHONE1"],
                        "CELL_PHONE2": defaultData["CELL_PHONE2"],
                        "LOV_BLOOD_TYPE": defaultData["LOV_BLOOD_TYPE"].split("|")[0],
                        "LOV_MARITAL_STATUS": defaultData["LOV_MARITAL_STATUS"].split("|")[0],
                        "LOV_GENDER": defaultData["LOV_GENDER"].split("|")[0],
                    }
                    let defaultPerson = {
                        PERSON: [{
                            ENTITY: localStorage.getItem('entity'),
                            CLIENT: localStorage.getItem('client'),
                            DOCUMENT_TYPE: defaultDocType[0],
                            NUMBER_ID: defaultNumberId,
                            NAME: defaultName,
                            OTHER_NAME: defaultOtherName,
                            LASTNAME: defaultLastName,
                            OTHER_LASTNAME: defaultOtherLastName,
                            ADDRESS: defaultAddress,
                            COUNTRY: defaultCountry[0],
                            DEPARTMENT: defaultDepartment[0],
                            CITY: defaultCity[0],
                            EMAIL: defaultEmail,
                            PIN: defaultPin,
                            ...defaultOtherData
                        }]
                    }
                    setExiste(true)
                    setPersona(defaultPerson)
                    setOtherData({
                        ...otherData,
                        ...defaultOtherData
                    })
                    setTipoDocumento({ 'value': '' + defaultDocType[0] + '', 'label': '' + defaultDocType[1] + '' })
                    setId(defaultNumberId)
                    setDocumento(defaultNumberId)
                    setApellido1(defaultLastName)
                    setApellido2(defaultOtherLastName)
                    setNombre(defaultName)
                    setOtroNombre(defaultOtherName)
                    setDireccion(defaultAddress)
                    setPais({ 'value': '' + defaultCountry[0] + '', 'label': '' + defaultCountry[1] + '' })
                    setDepartamento({ 'value': '' + defaultDepartment[0] + '', 'label': '' + defaultDepartment[1] + '' })
                    setCiudad({ 'value': '' + defaultCity[0] + '', 'label': '' + defaultCity[1] + '' })
                    setEmail(defaultEmail)
                    setPin(defaultPin)
                    setFotoEmpleado(foto)
                    localStorage.setItem('image', foto)
                }
                setLoadPage(true)
            })
        } catch (err) {
            setLoadPage(true)
            console.log(err.response)
            cleanPerson();
        }
    }

    const showConfirm = (name, id, process) => {
        /*Función encragada de mostrarle al usuario un mensaje de confirmación de la ejecución de un proceso*/
        console.log(name, id, process)
        toast.current.show({
            severity: 'success', sticky: true, content: (
                <div className="flex flex-column" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i className="pi pi-check-circle" style={{ fontSize: '3rem', color: "green" }}></i>
                        <p>Persona {name}({id}) {process} existosamente</p>
                    </div>
                    {localStorage.getItem('type') === "ADMIN" && <div style={{ justifyContent: 'center' }} className="grid p-fluid">
                        <a style={{ textDecoration: 'none' }} href="/CreateEmployee">
                            <Button type="button" label="Aceptar" className="p-button-success" />
                        </a>
                    </div>}
                </div>
            )
        });
    }

    const didNotUpdate = (id) => {
        /*Función encargada de mostrar un mensaje dado el caso de que no se modifique ningún dato de la persona, 
          pero igualmente, el usuario trate de hacer la actulaización*/
        setLoading1(false)
        toast.current.show({
            severity: 'info', sticky: true, content: (
                <div className="flex flex-column" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i className="pi pi-info-circle" style={{ fontSize: '3rem', color: "blue" }}></i>
                        <p>Nada por actualizar ¿Desea pasar a la información de contrato?</p>
                    </div>
                    <div style={{ justifyContent: 'center' }} className="grid p-fluid">
                        <div className="col-6">
                            <a style={{ textDecoration: 'none' }} href="/CreateEmployee" 
                            disabled={!JSON.parse(localStorage.getItem('options_web')).some(opt => opt.items.some(item => item.label === 'CreateEmployee'))}>
                                <Button type="button" label="Si" onClick={() => localStorage.setItem('number_id', id)} />
                            </a>
                        </div>
                        <div className="col-6">
                            <a style={{ textDecoration: 'none' }}>
                                <Button type="button" label="Cancelar" onClick={() => toast.current.clear()} />
                            </a>
                        </div>
                    </div>
                </div>
            )
        });
    }

    async function postIdentityInfo() {
        /*Función encargada de crear una persona en la base de datos*/
        const _tipoDocumento = tipoDocumento.value;
        const _documento = documento;
        const _nombre = nombre;
        const _otroNombre = otroNombre;
        const _apellido1 = apellido1;
        const _apellido2 = apellido2;
        const _direccion = direccion;
        const _pais = pais.value;
        const _departamento = departamento.value;
        const _ciudad = ciudad.value;
        const _email = email;

        let _personID = ""

        const person = {
            DOCUMENT_TYPE: _tipoDocumento,
            NUMBER_ID: _documento,
            NAME: _nombre,
            OTHER_NAME: _otroNombre,
            LASTNAME: _apellido1,
            OTHER_LASTNAME: _apellido2,
            ADDRESS: _direccion,
            COUNTRY: _pais,
            DEPARTMENT: _departamento,
            CITY: _ciudad,
            EMAIL: _email
        }
        console.log(person)
        const headers = { authorization: localStorage.getItem('token') }

        try {
            await apis.postIdentity(person, headers).then(res => {
                _personID = res.data.PERSON[0]["NUMBER_ID"]
                localStorage.setItem('number_id', _personID);
                setLoading1(false)
                showConfirm(res.data.PERSON[0]["NAME"], _personID, "creada")
            })
        }
        catch (err) {
            setLoading1(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function putIdentityInfo() {
        /*Función encargada de actualizar la información de una persona*/
        const _tipoDocumento = tipoDocumento.value;
        const _documento = documento;
        const _nombre = nombre;
        const _otroNombre = otroNombre;
        const _apellido1 = apellido1;
        const _apellido2 = apellido2;
        const _direccion = direccion;
        const _pais = pais.value;
        const _departamento = departamento.value;
        const _ciudad = ciudad.value;
        const _email = email;
        const _pin = pin;
        const _cliente = localStorage.getItem("client")
        const _entidad = localStorage.getItem("entity")

        let _personID = ""

        const person = {
            PERSON: [{
                CLIENT: _cliente,
                ENTITY: _entidad,
                DOCUMENT_TYPE: _tipoDocumento,
                NUMBER_ID: _documento,
                NAME: _nombre,
                OTHER_NAME: _otroNombre,
                LASTNAME: _apellido1,
                OTHER_LASTNAME: _apellido2,
                ADDRESS: _direccion,
                COUNTRY: _pais,
                DEPARTMENT: _departamento,
                CITY: _ciudad,
                EMAIL: _email,
                PIN: _pin,
                ...otherData
            }]
        }
        const headers = { authorization: localStorage.getItem('token') }
        if (_.isEqual(person["PERSON"][0], persona["PERSON"][0])) {
            didNotUpdate(person["PERSON"][0]["NUMBER_ID"])
        }
        else {
            try {
                await apis.putIdentity(person, headers).then(res => {
                    setLoading1(false)
                    showConfirm(res.data.PERSON[0]["NAME"], localStorage.getItem('number_id'), "actualizada")
                })
            }
            catch (err) {
                setLoading1(false)
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            }
        }
    }

    async function processes() {
        /*Función encargada de validar si la persona existe, para así decir que proceso ejecutar*/
        if (id == undefined || id == -1 || id == null || id == "") {
            postIdentityInfo();
        }
        else {
            putIdentityInfo();
        }
    }

    /*Renderizado del componente*/
    return (
        <div className="surface-100 px-4 py-5 md:px-6 lg:px-8r w-full"
            style={{
                width: width < 960 && '100%',
            }}
        >
            {/* <Form onSubmit={handleSubmit}> */}
            <Toast ref={toast} style={{ backgroundColor: 'white' }} />
            <div style={{
                marginBottom: "2rem",
                marginTop: "5rem",
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'justify'
            }}
                className="mb-3 font-bold text-4xl flex justify-content-center align-items-center">
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    flexDirection: width > 960 ? 'row' : 'column-reverse'
                }}>
                    <img className='border-1' alt={""} src={fotoEmpleado} width={120} height={120}
                        style={{
                            verticalAlign: 'middle',
                            borderRadius: '60px',
                            marginRight: width > 960 && "8rem"
                        }}
                    />
                    <span className="text-900"
                        style={{
                            marginRight: width > 960 && "16rem"
                        }}
                    >
                        Información personal
                    </span>
                </div>
                <Label htmlFor="label"
                    style={{
                        // marginLeft: width > 960 && "20rem",
                        // position: 'fixed',
                        marginTop: "2rem"
                    }}
                >
                    (*) Campos obligatorios
                </Label>
            </div>
            <SkeletonTable load={loadPage} width="100%">
                <Forms>
                    <Card title="Datos personales" style={cardStyle}>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Tipo documento*</Label>
                                <Dropdown value={tipoDocumento} autofocus
                                    filter showClear filterBy="label" emptyMessage={"No hay tipos disponibles"}
                                    disabled={true}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setTipoDocumento({ "value": e.value, "label": label })
                                    }}
                                    options={listaTipoDocumento} placeholder={tipoDocumento.label} />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">{width > 320 ? "Número" : "N°"} documento*</Label>
                                <InputText
                                    id="label1"
                                    type="text"
                                    maxLength={12}
                                    value={documento}
                                    disabled={true}
                                    onChange={(e) => setDocumento(e.target.value)}
                                />
                            </FormGroup>
                        </Div>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Nombre 1 *</Label>
                                <InputText
                                    id="label2"
                                    type="text"

                                    value={nombre}
                                    onChange={(e) => setNombre(e.target.value)}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Otro nombre</Label>
                                <InputText
                                    id="label3"
                                    type="text"

                                    value={otroNombre}
                                    onChange={(e) => setOtroNombre(e.target.value)}
                                />
                            </FormGroup>
                        </Div>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Apellido 1 *</Label>
                                <InputText
                                    id="label4"
                                    type="text"

                                    value={apellido1}
                                    onChange={(e) => setApellido1(e.target.value)}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Apellido 2</Label>
                                <InputText
                                    id="label5"
                                    type="text"

                                    value={apellido2}
                                    onChange={(e) => setApellido2(e.target.value)}
                                />
                            </FormGroup>
                        </Div>
                    </Card>
                    <Card title="Datos de contacto" style={cardStyle}>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Dirección *</Label>
                                <InputText
                                    id="label6"
                                    type="text"

                                    value={direccion}
                                    onChange={(e) => setDireccion(e.target.value)}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">País *</Label>
                                <Dropdown value={pais} options={listaPais}
                                    filter showClear filterBy="label" emptyMessage={"No hay países disponibles"}
                                    placeholder={pais.label}
                                    onChange={(e) => {
                                        try {
                                            let label = e.originalEvent.nativeEvent.target.textContent;
                                            setPais({ "value": e.value, "label": label });
                                        } catch (err) {
                                            console.log("Wait")
                                        }
                                    }}
                                />
                            </FormGroup>
                        </Div>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Departamento *</Label>
                                <Dropdown value={departamento} options={listaDepartamento}
                                    filter showClear filterBy="name" emptyMessage={"No hay departamentos disponibles"}
                                    onChange={(e) => {
                                        try {
                                            setDepartamento({ "value": e.value.code, "label": e.value.name });
                                        } catch (err) {
                                            console.log("Wait")
                                        }
                                    }}
                                    placeholder={departamento.label} optionLabel='name'
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Ciudad *</Label>
                                <Dropdown value={ciudad}
                                    filter showClear filterBy="cname" emptyMessage={"No hay ciudades disponibles"}
                                    onChange={(e) => {
                                        try {
                                            setCiudad({ "value": e.value.code, "label": e.value.cname })
                                        } catch (err) {
                                            console.log("Wait")
                                        }
                                    }}
                                    options={listaCiudad} placeholder={ciudad.label} optionLabel="cname"
                                />
                            </FormGroup>
                        </Div>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Email personal *</Label>
                                <InputText
                                    id="label7"
                                    type="email"

                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label" style={{fontWeight: 'bolder'}}>PIN</Label>
                                <InputText
                                    id="label7"
                                    type="number"
                                    className='pin'
                                    value={pin}
                                    disabled
                                    onChange={(e) => setPin(e.target.value)}
                                />
                            </FormGroup>
                        </Div>
                    </Card>
                    <div>
                        <Button type="submit" label="Guardar" loading={loading1} href={localStorage.getItem('type') === "ADMIN" && "/CreateEmployee"} disabled={!validateForm()} onClick={() => { setLoading1(true); processes() }} style={{ marginRight: "0.5rem" }} />
                    </div>
                </Forms>
            </SkeletonTable>
            {/* </Form> */}
        </div>
    );
}